/*
 *    Copyright (c) 2018-2025, sems All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * Redistributions of source code must retain the above copyright notice,
 * this list of conditions and the following disclaimer.
 * Redistributions in binary form must reproduce the above copyright
 * notice, this list of conditions and the following disclaimer in the
 * documentation and/or other materials provided with the distribution.
 * Neither the name of the pig4cloud.com developer nor the names of its
 * contributors may be used to endorse or promote products derived from
 * this software without specific prior written permission.
 * Author: sems
 */

import BaseApi from '../base'

export default class UserApi extends BaseApi {
  constructor() {
    super('/admin/user')
  }

  getUsersWithProfiles = () => this.get(`${this.path}/list`)

  getDetails = obj => this.get(`${this.path}/details/${obj}`)

  // 更改个人信息
  editInfo = obj => this.put(`${this.path}/edit`, obj)

  // 更新打卡地点选择员工
  updateUserAttendance = obj => this.put(`${this.path}/update-user-foreign-key`, obj)

  /**
   * 微信和小程序解绑
   */
  unBindSocial = state => this.get(`/admin/social/un-bind/${state}`)

  updateBatch = list => this.put(`${this.path}/batch`, list)

  // 重置密码
  resetAdminPassword = tenantId => this.post(`${this.path}/reset-password/${tenantId}`)

  // 校验登录密码
  validateUserPassword = password =>
    this.post(`${this.path}/validate-password?password=${password}`)

  // 获取指定用户权限范围
  getUserDataScope = userId => this.get(`${this.path}/data-scope/${userId}`)

  static GetInstance = () => new UserApi()
}
